/**
 * Converts flat factory fields to the nested event schema the adapter expects.
 * This is the reverse of FIELD_MAP in adobeAdapter.js — factory code uses flat
 * keys (section, page, category, label) but the adapter expects nested namespaces
 * (page.section, page.name, interaction.category, interaction.label).
 */
const FLAT_TO_NESTED = {
  // page namespace
  section: ["page", "section"],
  subsection: ["page", "subsection"],
  page: ["page", "name"],
  technologyName: ["page", "technologyName"],

  // product namespace
  modelName: ["product", "modelName"],
  modelYear: ["product", "modelYear"],
  modelCode: ["product", "modelCode"],
  trim: ["product", "trim"],
  modelEngine: ["product", "modelEngine"],
  modelCab: ["product", "modelCab"],
  modelBed: ["product", "modelBed"],
  modelDrivetrain: ["product", "modelDrivetrain"],

  // interaction namespace
  category: ["interaction", "category"],
  label: ["interaction", "label"],
  container: ["interaction", "container"],
  module: ["interaction", "module"],
  action: ["interaction", "action"],
  tilePosition: ["interaction", "tilePosition"],

  // content namespace
  contentTitle: ["content", "title"],
  mediaTitle: ["content", "mediaTitle"],
  categoryTopic: ["content", "categoryTopic"],
  articleType: ["content", "articleType"],
  description: ["content", "description"],

  // search namespace
  keyword: ["search", "keyword"],
  numberOfSearchResults: ["search", "resultCount"],

  // video namespace
  events: ["video", "event"],
  videoLength: ["video", "length"],

  // user namespace
  positionTitle: ["user", "positionTitle"],
};

export function toNested(flat) {
  const result = {};
  for (const [key, value] of Object.entries(flat)) {
    if (value === undefined) {
      continue;
    }
    const mapping = FLAT_TO_NESTED[key];
    if (mapping) {
      const [ns, field] = mapping;
      (result[ns] ??= {})[field] = value;
    } else {
      // tag, app, etc. stay top-level
      result[key] = value;
    }
  }
  return result;
}
